import store from "@/store/index.js";
export default (Vue) => {
    let hasPermission = false;
    // 自定义按钮权限指令
    Vue.directive("has", {
        inserted (el, binding) {
            let permissionList = store.getters.buttonPermissionList;
            hasPermission = false;
            permissionList.forEach(item => {
                if (item.key === binding.value) {
                    hasPermission = true;
                    return false;
                }
            });
            if (!hasPermission) {
                el.parentNode.removeChild(el);
            }
        }
    });
};



// WEBPACK FOOTER //
// ./src/data/permission.js